import { wioCapitalV1 } from './v1';

/** Versiones del test de Wio Capital. `current` es la que se usa para nuevas altas. */
export const wioCapital = {
  versions: { v1: wioCapitalV1 },
  current: wioCapitalV1,
};
